import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SharedService } from '../../../services/SharedService/sharedService';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {

  constructor(
    private sharedService: SharedService,
    private router: Router,
  ) { }
  @Input() LoginDetails: any;

  /** Hardcoded sidebar products (no SharedService / API). */
  readonly supplierProducts: ReadonlyArray<{ ProductID: number; Product: string }> = [
    { ProductID: 114, Product: 'Two Wheeler' },
    { ProductID: 117, Product: 'Car' }
  ];
  activeProductId: number | null = 117;
  productsExpanded = true;
  /** Products block on dashboard and pending-cases only */
  showSidebarProducts = false;
  private routeEventsSub?: Subscription;

  ngOnInit(): void {
    this.applyRouteForProducts(this.router.url);
    this.routeEventsSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.applyRouteForProducts(e.urlAfterRedirects));

    this.activeProductId = this.resolveSidebarProductId(this.sharedService.getUserDetailsSnapshot());
  }

  private resolveSidebarProductId(user: any): number | null {
    const pid = Number(user?.ProductID ?? user?.ProductId);
    if (Number.isFinite(pid) && this.supplierProducts.some((p) => p.ProductID === pid)) {
      return pid;
    }
    return null;
  }

  ngOnDestroy(): void {
    this.routeEventsSub?.unsubscribe();
  }

  private applyRouteForProducts(url: string): void {
    const path = ((url || '').split('?')[0] || '/').replace(/\/+$/, '') || '/';
    this.showSidebarProducts = path === '/dashboard' || path === '/pending-cases';
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['LoginDetails']) {
  //     this.loadSupplierProducts();
  //   }
  // }

  // private loadSupplierProducts(): void {
  //   const surveyorName =
  //     this.LoginDetails?.surveyorname ??
  //     this.LoginDetails?.SurveyorName ??
  //     this.LoginDetails?.Insurer ??
  //     this.LoginDetails?.UserName ??
  //     '';
  //   if (typeof surveyorName !== 'string' || !String(surveyorName).trim()) {
  //     this.sharedService.ensureSupplierProductsLoaded('');
  //     return;
  //   }
  //   this.sharedService.ensureSupplierProductsLoaded(surveyorName);
  // }

  setActiveProduct(item: any): void {
    const raw =
      item?.ProductID ??
      null;
    const nextProductId = raw != null ? Number(raw) : NaN;
    if (!Number.isFinite(nextProductId)) return;

    const currentUser = this.sharedService.getUserDetailsSnapshot();
    if (!currentUser || Object.keys(currentUser).length === 0) return;

    const productName = item?.Product ?? item?.product ?? '';
    const nextUser = { ...(currentUser || {}), ProductID: nextProductId, ProductName: productName };

    localStorage.setItem('currentUser', JSON.stringify(nextUser));
    this.sharedService.setUserDetails(nextUser);
    this.activeProductId = nextProductId;
  }

  toggleProductsExpanded(): void {
    this.productsExpanded = !this.productsExpanded;
  }
}
